import SummaryLine from "./summary-line.vue";

export default SummaryLine;



// WEBPACK FOOTER //
// ./src/components/_charts/chart-types/summary-line/index.js